// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n/* The blur is animated via backdrop-filter (not opacity) because\n   backdrop-filter ignores ancestor opacity and would pop in/out.\n   The enter/leave ramp lives in ModalBox as keyframe animations. */\n.overlay-backdrop[data-v-155c35d2] {\n\tbackground-color: rgb(0 0 0 / 0.45);\n\tbackdrop-filter: blur(4px);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
